import { render, staticRenderFns } from "./imperialUnitsSetting.vue?vue&type=template&id=226b49be&"
import script from "./imperialUnitsSetting.vue?vue&type=script&lang=js&"
export * from "./imperialUnitsSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('226b49be')) {
      api.createRecord('226b49be', component.options)
    } else {
      api.reload('226b49be', component.options)
    }
    module.hot.accept("./imperialUnitsSetting.vue?vue&type=template&id=226b49be&", function () {
      api.rerender('226b49be', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/SystemMaintenance/components/basicConfig/imperialUnitsSetting.vue"
export default component.exports